import api from "./api";

export async function listClientes(q) {
  const { data } = await api.get("/Clientes", { params: q ? { q } : undefined });
  return data;
}

export async function getCliente(id) {
  const { data } = await api.get(`/Clientes/${id}`);
  return data;
}

export async function createCliente(payload) {
  const { data } = await api.post("/Clientes", payload);
  return data;
}

export async function updateCliente(id, payload) {
  await api.put(`/Clientes/${id}`, payload);
}

export async function deleteCliente(id) {
  await api.delete(`/Clientes/${id}`);
}
